import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import {
  APPS_FEATURE,
  APPS_FILES,
} from '../../../../../store/utils/files-names';
import { FileMetadataModel } from '../../../../shared/models/file-metadata.model';

export const getAppsFilesSelector = (
  state: AppRootState
): FileMetadataModel[] => get(state, `${APPS_FEATURE}.${APPS_FILES}`).appsFiles;
